import {
  GET_INVOICES_REQUEST,
  GET_INVOICES_SUCCESS,
  GET_INVOICES_ERROR,
} from "./actions";

const initialState = {
  invoices: null,
  requesting: false,
  error: undefined,
  successful: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INVOICES_REQUEST:
      return {
        requesting: true,
        successful: false,
        invoices: undefined,
        error: undefined,
      };

    case GET_INVOICES_SUCCESS:
      return {
        requesting: false,
        successful: true,
        invoices: action.invoices,
        error: undefined,
      };

    case GET_INVOICES_ERROR:
      return {
        requesting: false,
        successful: false,
        invoices: undefined,
        error: action.error,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/userinvoices/reducer.js